<template>
    <div class="member-review-status">
        <div class="member-review-status-card">
            <h2>This link has expired</h2>
            <p>Your review session has ended or the link is no longer valid. Please open the link from your email or text message again.</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'MemberReviewExpired',
};
</script>

<style scoped>
.member-review-status {
    background: #f3f6f8;
    padding: 5rem 1rem;
    min-height: 60vh;
}
.member-review-status-card {
    max-width: 560px;
    margin: 0 auto;
    background: #fff;
    border-radius: 15px;
    box-shadow: 0 2px 15px rgb(216 227 235 / 33%);
    padding: 2rem;
    text-align: center;
}
.member-review-status-card h2 {
    font-size: 22px;
    color: #2c3f58;
    font-weight: 700;
}
.member-review-status-card p {
    color: #778699;
    font-size: 14px;
    margin: 0;
}
</style>
